<div *ngIf="isSkeleton">
    <div fxLayout="row wrap" fxLayoutAlign="space-between start" class="m-r-15 m-l-15">
        <div fxFlex="10">
            <ngx-skeleton-loader count="1" [theme]="{height: '40px', width: '102%', margin: '-3px'}">
            </ngx-skeleton-loader>
        </div>
        <div fxFlex="10">
            <ngx-skeleton-loader count="1" [theme]="{height: '40px', width: '102%', margin: '-3px'}">
            </ngx-skeleton-loader>
        </div>
    </div>
    <div fxLayout="row wrap">
        <mat-card fxFlex>
            <ngx-skeleton-loader count="1" [theme]="{height: '55px', margin: '-3px' }">
            </ngx-skeleton-loader>
            <mat-card class="m-10">
                <ngx-skeleton-loader count="1" [theme]="{height: '300px'}">
                </ngx-skeleton-loader>
            </mat-card>
        </mat-card>
    </div>
    <div fxLayout="row wrap" fxLayoutAlign="space-between start" class="m-15">
        <div fxFlex="10">
            <ngx-skeleton-loader count="1" [theme]="{height: '40px', width: '102%', margin: '-3px'}">
            </ngx-skeleton-loader>
        </div>
        <div fxFlex="10">
            <ngx-skeleton-loader count="1" [theme]="{height: '40px', width: '102%', margin: '-3px'}">
            </ngx-skeleton-loader>
        </div>
    </div>
    <div fxLayout="row wrap" fxLayoutAlign="start center">
        <div fxFlex="6">
            <ngx-skeleton-loader count="1" appearance="circle" [theme]="{height: '60px', width: '60px'}">
            </ngx-skeleton-loader>
        </div>
        <div fxFlex="30">
            <ngx-skeleton-loader count="1" [theme]="{height: '50px', width: '102%', margin: '-3px'}">
            </ngx-skeleton-loader>
        </div>
    </div>
</div>

<div *ngIf="!isSkeleton">
    <div fxLayout="row wrap" fxLayoutAlign="space-between center" class="m-l-r-15">
        <div>
            <div fxLayout="row wrap" fxLayoutAlign="start center">
                <button *ngIf="this.popupData&&!this.popupData.type" class="m-r-10" type="button" (click)="onBack()"
                    mat-raised-button color="primary">Back</button>
                <mat-icon *ngIf="this.popupData&&this.popupData.type" class="m-r-5">person</mat-icon>
                <div class="p-name">{{patientDetails.fname}} {{patientDetails.lname}}</div>
            </div>
        </div>
        <div fxLayoutAlign="center center">
            <div>
                <button *ngIf="actionTemplates.length || printTemplates.length || this.popupData&&!this.popupData.type" class="action-dropdown"
                    mat-raised-button [matMenuTriggerFor]="actionsMenu">
                    Actions <mat-icon>arrow_drop_down</mat-icon>
                </button>
                <mat-menu #actionsMenu="matMenu" xPosition="before">
                    <button *ngIf="this.popupData&&!this.popupData.type" mat-menu-item (click)="selectQueue()">
                        <mat-icon>add_to_queue</mat-icon>
                        <span>Add to queue</span>
                    </button>
                    <button *ngIf="printTemplates.length" mat-menu-item (click)="printInvoiceTemplates()">
                        <mat-icon>print</mat-icon>
                        <span>Print and Export</span>
                    </button>
                    <div *ngFor="let item of actionTemplates" mat-menu-item fxLayoutAlign="start center">
                        <mat-icon>{{item.iconHtml}}</mat-icon>
                        <app-template [htmlText]="item.htmlText" [customInputs]="item.questions">
                        </app-template>
                    </div>
                </mat-menu>
            </div>
            <div *ngIf="this.popupData&&this.popupData.type" (click)="onClosePopup()" class="close-btn m-l-20"
                fxLayoutAlign="center center">
                <mat-icon>clear</mat-icon>
            </div>
        </div>
    </div>
    <div fxLayout="row wrap">
        <mat-card fxFlex.gt-sm="22.5" fxFlex="100" fxFlex.sm="50" *ngIf="!userPageSettings.cards.profile.hide">
            <mat-card-content>
                <div fxLayout="row wrap" fxLayoutAlign.xs="center center"
                    *ngIf="!userPageSettings.cards.profile.hideContent">
                    <div fxFlex.gt-sm="35" fxFlex.gt-xs="35">
                        <button mat-fab color="primary" mat-card-icon class="shadow-none">
                            <mat-icon>account_circle</mat-icon>
                        </button>
                    </div>
                    <div fxFlex.gt-sm="65" fxFlex.gt-xs="65">
                        <h5 class="m-0" *ngIf="patientDetails.fname">{{patientDetails.fname}} {{patientDetails.lname}}
                        </h5>
                        <label class="text-muted"
                            *ngIf="patientDetails.birthDate">{{patientDetails.birthDate | date : 'MM-DD-YYYY'}}</label><br />
                        <label class="text-muted" *ngIf="patientDetails.email">{{patientDetails.email}}</label><br />
                        <label class="text-muted" *ngIf="patientDetails.phone">{{patientDetails.phone}}</label><br />
                    </div>
                </div>
                <div class="lock-bottom" *ngIf="userPageSettings.cards.profile.lock">
                    <mat-icon class="font-20">lock</mat-icon>
                </div>
            </mat-card-content>
        </mat-card>

        <mat-card fxFlex.gt-sm="22.5" fxFlex.gt-xs="100" fxFlex="100" fxFlex.sm="50"
            *ngIf="!userPageSettings.cards.riskAssessment.hide">
            <mat-card-content>
                <div fxLayout="row wrap" fxLayoutAlign="center start">
                    <div fxFlex.gt-sm="100" fxFlex.gt-xs="100" fxFlex="100" fxLayoutAlign="center start">
                        <h5 class="m-0">Risk Assessment</h5>
                    </div>
                </div>
                <div fxLayout="column" fxLayoutAlign="center center"
                    *ngIf="!userPageSettings.cards.riskAssessment.hideContent">
                    <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="5px">
                        <div class="round round-success w-15 h-15 green"></div>
                        <div fxLayout="row" fxLayoutAlign="center start">
                            <label>Health <label class="text-muted">({{profile.health}}/1000)</label></label>
                        </div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="7px">
                        <div class="round round-danger w-15 h-15 red"></div>
                        <div fxLayout="row" fxLayoutAlign="center start">
                            <label>Behavior <label class="text-muted">({{profile.behavior}}/100)</label></label>
                        </div>
                    </div>
                </div>
                <div class="lock-bottom" *ngIf="userPageSettings.cards.riskAssessment.lock">
                    <mat-icon class="font-20">lock</mat-icon>
                </div>
            </mat-card-content>
        </mat-card>

        <mat-card fxFlex.gt-sm="22.5" fxFlex.gt-xs="100" fxFlex="100" fxFlex.sm="50"
            *ngIf="!userPageSettings.cards.socialDeterminants.hide">
            <mat-card-content>
                <div fxLayout="row wrap" fxLayoutAlign="center start">
                    <div fxFlex.gt-sm="100" fxFlex.gt-xs="100" fxFlex="100" fxLayoutAlign="center start">
                        <h5 class="m-0">Social Determinants</h5>
                    </div>
                </div>
                <div fxLayout="row" fxLayoutAlign="space-between start" fxLayoutGap="20px"
                    *ngIf="!userPageSettings.cards.socialDeterminants.hideContent">
                    <mat-icon [ngClass]="{'text-muted': !profile.barriers.money}">attach_money</mat-icon>
                    <i class="ti-world p-t-5" [ngClass]="{'text-muted': !profile.barriers.internet}"></i>
                    <mat-icon [ngClass]="{'text-muted': !profile.barriers.travel}">directions_car</mat-icon>
                    <mat-icon [ngClass]="{'text-muted': !profile.barriers.handicap}">accessible</mat-icon>
                    <img class="w-10p p-t-2" src="assets/icons/barriers/chatbubble_black.png"
                        *ngIf="profile.barriers.communication">
                    <img class="w-10p p-t-2" src="assets/icons/barriers/chatbubble_grey.png"
                        *ngIf="!profile.barriers.communication">
                </div>
                <div class="lock-bottom" *ngIf="userPageSettings.cards.socialDeterminants.lock">
                    <mat-icon class="font-20">lock</mat-icon>
                </div>
            </mat-card-content>
        </mat-card>

        <mat-card fxFlex.gt-sm="22.5" fxFlex.gt-xs="100" fxFlex="100" fxFlex.sm="50"
            *ngIf="!userPageSettings.cards.preferredChannels.hide">
            <mat-card-content>
                <div fxLayout="row wrap" fxLayoutAlign="center start">
                    <div fxFlex.gt-sm="100" fxFlex.gt-xs="100" fxFlex="100" fxLayoutAlign="center start">
                        <h5 class="m-0">Preferred Channels</h5>
                    </div>
                </div>
                <div fxLayout="row" fxLayoutAlign="space-between start" fxLayoutGap="35px"
                    *ngIf="!userPageSettings.cards.preferredChannels.hideContent">
                    <mat-icon [ngClass]="{'text-muted': !profile.channels.phone}">local_phone</mat-icon>
                    <mat-icon [ngClass]="{'text-muted': !profile.channels.email}">email</mat-icon>
                    <mat-icon [ngClass]="{'text-muted': !profile.channels.mobile}">stay_current_portrait</mat-icon>
                    <img class="w-10p p-t-2" src="assets/icons/channels/app_store_black.png"
                        *ngIf="profile.channels.app">
                    <img class="w-10p p-t-2" src="assets/icons/channels/app_store_grey.png"
                        *ngIf="!profile.channels.app">
                </div>
                <div class="lock-bottom" *ngIf="userPageSettings.cards.preferredChannels.lock">
                    <mat-icon class="font-20">lock</mat-icon>
                </div>
            </mat-card-content>
        </mat-card>
    </div>

    <div fxLayout="row wrap">
        <div fxFlex.gt-sm="100" fxFlex="100">
            <mat-card>
                <mat-tab-group dynamicHeight (selectedTabChange)="onTabChange($event.index)">
                    <mat-tab [disabled]="userPageSettings.tab.profile.disable"
                        *ngIf="!userPageSettings.tab.profile.hide">
                        <ng-template mat-tab-label>
                            Profile
                            <mat-icon class="font-20" *ngIf="userPageSettings.tab.profile.lock">lock</mat-icon>
                        </ng-template>
                        <app-summary *ngIf="tabs.profile" [config]="summaryScreenConfig" [patientId]="patientId"
                            [patientDetails]="patientDetails" (onSuccess)="onEditProfile($event)"></app-summary>
                    </mat-tab>

                    <mat-tab [disabled]="userPageSettings.tab.assessment.disable"
                        *ngIf="!userPageSettings.tab.assessment.hide">
                        <ng-template mat-tab-label>
                            <span [matBadge]="assessmentCount" matBadgeOverlap="false">Assessment</span>
                            <mat-icon class="font-20" *ngIf="userPageSettings.tab.assessment.lock">lock</mat-icon>
                        </ng-template>
                        <app-survey *ngIf="tabs.assessment" [patientId]="patientId" [patientDetails]="patientDetails"
                            (count)="assessmentCountFun($event)"></app-survey>
                    </mat-tab>

                    <mat-tab [disabled]="userPageSettings.tab.appointment.disable"
                        *ngIf="!userPageSettings.tab.appointment.hide">
                        <ng-template mat-tab-label>
                            <span *ngIf="!userPageSettings.tab.appointment.lock" [matBadge]="appointmentCount"
                                matBadgeOverlap="false">Appointment</span>
                            <span *ngIf="userPageSettings.tab.appointment.lock">Appointment</span>
                            <mat-icon class="font-20" *ngIf="userPageSettings.tab.appointment.lock">lock</mat-icon>
                        </ng-template>
                        <app-appointment *ngIf="tabs.appointment" [patientId]="patientId"
                            [patientDetails]="patientDetails" (count)="appointmentCountFun($event)"></app-appointment>
                    </mat-tab>

                    <mat-tab [disabled]="userPageSettings.tab.documents.disable"
                        *ngIf="!userPageSettings.tab.documents.hide">
                        <ng-template mat-tab-label>
                            <span [matBadge]="documentsCount" matBadgeOverlap="false">Documents</span>
                            <mat-icon class="font-20" *ngIf="userPageSettings.tab.documents.lock">lock</mat-icon>
                        </ng-template>
                        <app-documents *ngIf="tabs.documents" [patientId]="patientId" [patientDetails]="patientDetails"
                            [isTabActivated]="isDocumentTabActivated" (count)="documentsCountFun($event)">
                        </app-documents>
                    </mat-tab>

                    <mat-tab [disabled]="userPageSettings.tab.care_plan.disable"
                        *ngIf="!userPageSettings.tab.care_plan.hide">
                        <ng-template mat-tab-label>
                            Care Plan
                            <mat-icon class="font-20" *ngIf="userPageSettings.tab.care_plan.lock">lock</mat-icon>
                        </ng-template>
                        <mat-card-content *ngIf="tabs.carePlan">
                            Content 1
                        </mat-card-content>
                    </mat-tab>

                    <mat-tab [disabled]="userPageSettings.tab.patient_engagement.disable"
                        *ngIf="!userPageSettings.tab.patient_engagement.hide">
                        <ng-template mat-tab-label>
                            Patient Engagement
                            <mat-icon class="font-20" *ngIf="userPageSettings.tab.patient_engagement.lock">lock
                            </mat-icon>
                        </ng-template>
                        <mat-card-content class="m-0" *ngIf="tabs.patientEngagement">
                            <app-patient-engagement *ngIf="tabs.patientEngagement" [patientId]="patientId"
                                [patientDetails]="patientDetails"></app-patient-engagement>
                        </mat-card-content>
                    </mat-tab>

                    <mat-tab [disabled]="userPageSettings.tab.workflow.disable"
                        *ngIf="!userPageSettings.tab.workflow.hide">
                        <ng-template mat-tab-label>
                            Workflow History
                            <mat-icon class="font-20" *ngIf="userPageSettings.tab.workflow.lock">lock</mat-icon>
                        </ng-template>
                        <mat-card-content class="m-0" *ngIf="tabs.workflow">
                            <app-workflow *ngIf="tabs.workflow" [patientId]="patientId"
                                [patientDetails]="patientDetails"></app-workflow>
                        </mat-card-content>
                    </mat-tab>

                    <mat-tab [disabled]="userPageSettings.tab.social_determinants.disable"
                        *ngIf="!userPageSettings.tab.social_determinants.hide">
                        <ng-template mat-tab-label>
                            Social Determinants
                            <mat-icon class="font-20" *ngIf="userPageSettings.tab.social_determinants.lock">lock
                            </mat-icon>
                        </ng-template>
                        <mat-card-content *ngIf="tabs.socialDeterminants">
                            <app-social-determinants></app-social-determinants>
                        </mat-card-content>
                    </mat-tab>

                    <mat-tab [disabled]="userPageSettings.tab.rewards.disable"
                        *ngIf="!userPageSettings.tab.rewards.hide">
                        <ng-template mat-tab-label>
                            Rewards
                            <mat-icon class="font-20" *ngIf="userPageSettings.tab.rewards.lock">lock</mat-icon>
                        </ng-template>
                        <mat-card-content *ngIf="tabs.rewards">

                        </mat-card-content>
                    </mat-tab>

                </mat-tab-group>
            </mat-card>
        </div>
    </div>
    <div class="m-l-r-15">
        <app-activities [patientId]="patientId"></app-activities>
    </div>
</div>